module.exports = __webpack_public_path__ + "img/04.4e551261.jpg";